//
// Helper functions for graph deserialization
//

export function deserializeGraph(services,
  joint,
  serializedGraph,
  jointGraph,
  paper,
  linkFactory,
  context,
  earlyResizeAndScrollCallback) {
  services.JointjsOptimisationsFactory.deserializingStarts();

  var deferred = services.$q.defer();

  // Create an array with all boxes
  let boxes = serializedGraph.elements ? Object.values(serializedGraph.elements) : [];

  // timeout to give angular a chance to display the scenario edition page
  services.$timeout(() => {

    // we must add all boxes to the graph before boxes children
    deserializeBoxes(services, joint, boxes, serializedGraph, jointGraph);

    earlyResizeAndScrollCallback();

    // timeout to give the browser a chance to display the boxes, to give the user the impression that something is going on
    services.$timeout(() => {
      // to create box children items
      const linksBatch = deserializeBoxItems(services, deferred, joint, boxes, serializedGraph, jointGraph, paper, linkFactory, context);

      // timeout to give angular and the browser a chance to render the box items
      services.$timeout(() => {
        addLinksBatchAndUpdateValidity(services, linksBatch, jointGraph, paper);
        services.JointjsOptimisationsFactory.deserializingEnds();
        deferred.resolve('deserialized');

        // timeout to give the browser a chance to remove display:none on the html-elements, as we'll need their size in resizeBox() calls
        services.$timeout(() => {
          if (serializedGraph.allElementsHaveSizeAndPosition) {
            forceResizeOldBoxes(jointGraph, serializedGraph.scenarioEditorVersion || 0, boxes, paper);
          }
        }, 10);
      }, 10);
    }, 10);
  }, 50);

  return deferred.promise;
}


function deserializeBoxes(services, joint, serializedBoxes, serializedGraph, jointGraph) {

  // Batching question cells adding for small perf boost.
  let boxesToAdd = [];

  for (let serializedBox of serializedBoxes) {
    let constructorSwitch = {
      'question': serializedBox.id === serializedGraph.root_id
        ? joint.shapes.html.RootQuestionBox
        : joint.shapes.html.QuestionBox,
      'messageWithChoiceBox': joint.shapes.html.MessageWithChoiceBox,
      'waitForAUserInputMessageBox': joint.shapes.html.WaitForMessageBox,
      'messageWithoutQRBox': joint.shapes.html.MessageWithoutQRBox,
      'surveyFeedbackBox': joint.shapes.html.SurveyFeedbackBox,
      'subBotBox':
        serializedBox.type === 'subBotBox' && serializedBox.elementData?.realType === 'aiConnector'
          ? joint.shapes.html.AiConnectorBox
          : joint.shapes.html.SubBotBox,
      'listPickerBox': joint.shapes.html.ListPickerBox,
      'whatsappListMessageBox': joint.shapes.html.WhatsappListMessageBox,
      'whatsappMessageWithButtonsBox': joint.shapes.html.WhatsappMessageWithButtonsBox,
      'whatsappTemplateBox': joint.shapes.html.WhatsappTemplateBox,
      'instagramCarrouselBox': joint.shapes.html.InstagramCarrouselBox,
      'gbmCarrouselBox': joint.shapes.html.GbmCarrouselBox,
      'lineCarrouselBox': joint.shapes.html.LineCarrouselBox,
      'inMessageCarouselBox': joint.shapes.html.InMessageCarouselBox,
      'imageCarrouselBox': joint.shapes.html.ImageCarrouselBox,
      'imageMapBox': joint.shapes.html.ImageMapBox,
      'botConnectorBox': joint.shapes.html.BotConnectorBox,
      'facebookProductBox': joint.shapes.html.FacebookProductBox,
      'recurringNotifBox': joint.shapes.html.RecurringNotifBox,
      'actionBox': joint.shapes.html.ActionBox,
      'handoverBox': joint.shapes.html.HandoverBox,
      'getStartedBox': joint.shapes.html.GetStartedBox,
      'surveyStartedBox': joint.shapes.html.SurveyStartedBox,
      'newConversationBox': joint.shapes.html.NewConversationBox,
      'unexpectedUserInputBox': joint.shapes.html.UnexpectedUserInputBox,
      'agentShortcutBox': joint.shapes.html.AgentShortcutBox,
      'massMessagingEntryPointBox': joint.shapes.html.MassMessagingEntryPointBox,
      'receiveControlBox': joint.shapes.html.ReceiveControlBox,
      'messengerMDotMeLinkBox': joint.shapes.html.MessengerMDotMeLinkBox,
      'externalEndpointEntryPointBox': joint.shapes.html.ExternalEndpointEntryPointBox,
      'linkWithRefEntryPointBox': joint.shapes.html.LinkWithRefEntryPointBox,
      'clickToMessengerBox': joint.shapes.html.ClickToMessengerBox,
      'sponsoredBzcMessageBox': joint.shapes.html.SponsoredBzcMessageBox,
      'messengerCustomAppEventFromVariableBox': joint.shapes.html.MessengerCustomAppEventFromVariableBox,
      'BZCRichLinkAManoBox': joint.shapes.html.BZCRichLinkAManoBox,
      'messengerGenericTemplateAManoBox': joint.shapes.html.MessengerGenericTemplateAManoBox,
      'messengerMediaTemplateAManoBox': joint.shapes.html.MessengerMediaTemplateAManoBox,
      'messengerButtonTemplateAManoBox': joint.shapes.html.MessengerButtonTemplateAManoBox,
      'ifThenElseBox': joint.shapes.html.IfThenElseBox,
      'BHNBHBox': joint.shapes.html.BHNBHBox,
      'EmailRequestForNotificationBox': joint.shapes.html.EmailRequestForNotificationBox,
      'PhoneRequestForNotificationBox': joint.shapes.html.PhoneRequestForNotificationBox,
      'userLanguagesBox': joint.shapes.html.UserLanguagesBox,
      'userCountriesBox': joint.shapes.html.UserCountriesBox,
      'optinNotOptinBox': joint.shapes.html.OptinNotOptinBox,
      'firstConversationEverBox': joint.shapes.html.FirstConversationEverBox,
      'followingConversationsBox': joint.shapes.html.FollowingConversationsBox,
      'whatsappCartSentBox': joint.shapes.html.WhatsappCartSentBox,
      'forkWithDelayBox': joint.shapes.html.ForkWithDelayBox,
      'triggerSurveyBox': joint.shapes.html.TriggerSurveyBox,
      'setCustomFieldBox': joint.shapes.html.SetCustomFieldBox,
      'promoCodeBox': joint.shapes.html.PromoCodeBox,
      'confirmBox': joint.shapes.html.ConfirmBox,
      'lineRichMenuBox': joint.shapes.html.LineRichMenuBox,
      'conditionsOnUserInputBox': joint.shapes.html.ConditionsOnUserInputBox,
      'conditionsVariablesMultipleBox': joint.shapes.html.ConditionsVariablesMultipleBox,
      'whatsappWelcomeMessageBox': joint.shapes.html.WhatsappWelcomeMessageBox,
      'customFieldsConditionsBox': joint.shapes.html.ConditionsOnCustomFieldsBox,
      'optinCTSBox': joint.shapes.html.OptinCTSBox,
      'apiConnectorBox': joint.shapes.html.ApiConnectorBox,
      'noteBox': joint.shapes.html.NoteBox,
      'aiSatisfactionBox': joint.shapes.html.AiSatisfactionBox,
      'textMatchBox': joint.shapes.html.TextMatchBox,
    };

    if (constructorSwitch[serializedBox.type]) {
      let attrs = {};
      // copy all known attributes, if present in the given box type
      // (position will be cloned in serializeGraph(), so we should be safe reference-copying it here)
      ['id', 'position', 'size', 'content', 'links', 'pictureId', 'videoId', 'fileId', 'fileName', 'emailSender', 'emailSubject',
        'emailContent', 'emailLinks', 'smsContent', 'smsLinks', 'landingPageUrl', 'user_input_answer_id',
        'phone_number_answer_id', 'email_answer_id', 'target_app_id', 'thread_control_metadata',
        'timeout', 'input_variable', 'variable_origin', 'origin_url', 'elements', 'expression', 'element', 'rich_link',
        'postback_payload', 'elementData', 'can_be_deleted', 'greeting_message', 'entrypoint_description', 'order', 'menuChoice',
        'spellCheckerLang', 'disableInput', 'ad_id', 'composer_input_disabled', 'delay_until_first_conversation_ever',
        'summaryText', 'maxNumberOfButtonsAllowed'
      ].forEach(attributeName => {
        if (serializedBox[attributeName] !== undefined) {
          attrs[attributeName] = serializedBox[attributeName];
        }
      });
      boxesToAdd.push(new constructorSwitch[serializedBox.type](attrs));
    } else {
      // answers, tagActions, handoverItems, etc are deserialized via their parents in the methods below
    }
  }
  services.JointjsOptimisationsFactory.setNumberOfBoxes(boxesToAdd.length);
  jointGraph.addCells(boxesToAdd);
}

/**
 * Deserializes the given boxes' children into the given jointJS graph
 */
function deserializeBoxItems(services, deferred, joint, serializedBoxes, serializedGraph, jointGraph, paper, linkFactory, context) {
  let linksBatch = [];
  for (let box of serializedBoxes) {
    switch (box.type) {
      case 'question':
      case 'messageWithChoiceBox':
      case 'EmailRequestForNotificationBox':
      case 'PhoneRequestForNotificationBox':
        deserializeAnswers(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.answers, paper, linkFactory, linksBatch);
        break;
      case 'waitForAUserInputMessageBox':
        deserializeAnswers(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'surveyFeedbackBox':
        deserializeSurveyFeedbackAnswers(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'subBotBox':
        deserializeSubBotExits(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'whatsappTemplateBox': {
        deserializeWhatsappTemplateExits(joint, serializedGraph, box, jointGraph, paper);
        deserializeNext(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      }
      case 'messageWithoutQRBox':
        deserializeMessageWithoutQRURLButtons(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeNext(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'actionBox':
        deserializeActions(joint, serializedGraph, box, jointGraph, paper, context);
        deserializeNext(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'handoverBox':
        deserializeHandoverItems(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'getStartedBox':
      case 'firstConversationEverBox':
        deserializeMenuItems(joint, serializedGraph, box, jointGraph, paper);
        deserializeNext(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'surveyStartedBox':
      case 'newConversationBox':
      case 'unexpectedUserInputBox':
      case 'agentShortcutBox':
      case 'massMessagingEntryPointBox':
      case 'receiveControlBox':
      case 'messengerMDotMeLinkBox':
      case 'externalEndpointEntryPointBox':
      case 'linkWithRefEntryPointBox':
      case 'clickToMessengerBox':
      case 'sponsoredBzcMessageBox':
      case 'messengerCustomAppEventFromVariableBox':
      case 'BZCRichLinkAManoBox':
      case 'ifThenElseBox':
      case 'BHNBHBox':
      case 'facebookProductBox':
      case 'recurringNotifBox':
      case 'optinNotOptinBox':
      case 'followingConversationsBox':
      case 'setCustomFieldBox':
      case 'lineRichMenuBox':
      case 'whatsappCartSentBox':
      case 'promoCodeBox':
      case 'customFieldsConditionsBox':
      case 'apiConnectorBox':
        deserializeNext(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'messengerGenericTemplateAManoBox':
      case 'messengerMediaTemplateAManoBox':
      case 'messengerButtonTemplateAManoBox':
        deserializeMessengerAManoChildren(joint, serializedGraph, box.id, box.buttonsAndHeaders, jointGraph, paper);
        deserializeLinks(serializedGraph, box.buttonsAndHeaders, paper, linkFactory, linksBatch);
        break;
      case 'userLanguagesBox':
        deserializeUserLanguages(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'userCountriesBox':
        deserializeUserCountries(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'listPickerBox':
      case 'whatsappListMessageBox':
        deserializeListPickerBox(joint, serializedGraph, box.id, box.children, jointGraph, paper, services, context);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'whatsappMessageWithButtonsBox':
        deserializeWhatsappMessageWithButtonsBox(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'lineCarrouselBox':
      case 'imageCarrouselBox':
        deserializeNext(joint, serializedGraph, box, jointGraph, paper);
        deserializeCarrouselBox(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'imageMapBox':
        // order is important, and defines the display order
        // the next is before the specifics buttons of the box
        deserializeNext(joint, serializedGraph, box, jointGraph, paper); // no more next, but some scenarios exists with
        deserializeImageMapBox(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'instagramCarrouselBox':
      case 'gbmCarrouselBox':
      case 'inMessageCarouselBox':
        deserializeCarrouselBox(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'forkWithDelayBox':
        deserializeForkWithDelayBox(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'confirmBox':
        deserializeConfirmBox(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'conditionsOnUserInputBox':
        deserializeNext(joint, serializedGraph, box, jointGraph, paper);
        deserializeConditionsOnUserInputBox(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'conditionsVariablesMultipleBox':
        deserializeConditionsVariablesMultipleBox(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeNext(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'whatsappWelcomeMessageBox':
        deserializeWhatsappWelcomeMessageBox(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeNext(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'optinCTSBox':
        deserializeOptinCTSTitle(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      case 'noteBox':
        context.noteBoxesSet.add(box.id);
        break;
      case 'aiSatisfactionBox': {
        deserializeAISatisfactionBox(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeNext(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      }
      case 'textMatchBox': {
        deserializeTextMatchBox(joint, serializedGraph, box.id, box.children, jointGraph, paper);
        deserializeNext(joint, serializedGraph, box, jointGraph, paper);
        deserializeLinks(serializedGraph, box.children, paper, linkFactory, linksBatch);
        break;
      }
      default:
        // answers, tagActions, handoverItems, etc are deserialized in the methods below
        break;
    }
  }
  return linksBatch;
}

function addLinksBatchAndUpdateValidity(services, linksBatch, jointGraph, paper) {
  services.JointjsOptimisationsFactory.setNumberOfLinks(linksBatch.length);
  jointGraph.addCells(linksBatch);
  linksBatch.forEach(link => {
    // We can only update validity after the links are effectively inserted in the graph,
    // because upadteValidity methods only computes validity for connected boxes
    const targetCellView = jointGraph.getCell(link.get('target').id).findView(paper);
    if (targetCellView.updateValidity) {
      targetCellView.updateValidity();
    }
  });
}

// Resizes boxes for which the size of the rendered box may have changed since the last time it was saved,
// because of some code change in the editor.
// (for performance reasons, we don't resize each box when the graph is deserialized;
// instead we use the positions and sizes of all boxes and child items as stored in the graph)
// For example, if a field and its label are added to a box, the label will appear when an old scenario is deserialized,
// and hence the box's size should be adjusted.
function forceResizeOldBoxes(jointGraph, version, serializedBoxes, paper) {
  const idsToResize = [];
  for (let box of serializedBoxes) {
    if (['getStartedBox', 'surveyStartedBox', 'newConversationBox', 'unexpectedUserInputBox',
      'messengerMDotMeLinkBox', 'receiveControlBox', 'externalEndpointEntryPointBox',
      'clickToMessengerBox', 'sponsoredBzcMessageBox',
      'firstConversationEverBox', 'followingConversationsBox', 'linkWithRefEntryPointBox', 'lineRichMenuBox', 'whatsappCartSentBox'
    ].includes(box.type) && version < 3) {
      // force resize to make room for the new 'scenario description' text and edit button
      idsToResize.push(box.id);
    }
  }
  for (let id of idsToResize) {
    jointGraph.getCell(id).findView(paper).resizeBox();
  }
}

/**
 * Deserializes the given Action's TagAction and Next children into the given jointJS graph
 */
function deserializeAnswers(joint, serializedGraph, serializedQuestion, jointGraph, paper) {

  let questionBox = jointGraph.getCell(serializedQuestion.id);
  let questionBoxView = paper.findViewByModel(questionBox);
  questionBoxView.numberOfButtons = 0;

  const answersBatch = [];
  const maxButtons = serializedQuestion.type === 'question' && questionBoxView.getConfigurationOption && questionBoxView.getConfigurationOption()?.maxAnswers;
  //loop on this question's answers
  const answers = serializedQuestion[serializedQuestion.type === 'waitForAUserInputMessageBox' ? 'children' : 'answers'] || [];
  for (let answerId of answers) {
    let answer = serializedGraph.elements[answerId];
    const canAddButton = !maxButtons || maxButtons > questionBoxView.numberOfButtons;
    if (['simple-text', 'url', 'app-link'].includes(answer.answerType)) {
      if (canAddButton) {
        questionBoxView.numberOfButtons++;
      } else {
        continue;
      }
    }
    // Note that questionBoxView can be a QuestionBoxView, a EmailRequestForNotificationBoxView or a PhoneRequestForNotificationBoxView
    answersBatch.push(questionBoxView.createAnswer(answer.id,
      answer.position,
      answer.size,
      answer.label,
      answer.description,
      answer.answerType,
      Boolean(answer.hasHandover),
      Boolean(answer.hasVerbatimMode),
      answer.pictureId, // TODO remove once gouvfr scenarios are migrated
      answer.pictureDataURL,
      answer.order,
      answer.inputListVariable,
      answer.templateJinjaVariable,
      answer.selectedButtonIndexVariable,
      answer.UrlButtonUrl,
      answer.UrlButtonUrlAndroid,
      answer.UrlButtonUrlIos,
      answer.UrlButtonName));
  }

  if (serializedQuestion.type === 'question') {
    // Add the missing mandatories buttons.
    const buttonBoxesNeeded = ((questionBoxView.getConfigurationOption && questionBoxView.getConfigurationOption()?.minAnswers) || 0) - questionBoxView.numberOfButtons;
    if (buttonBoxesNeeded > 0) {
      Array.from({ length: buttonBoxesNeeded }).forEach(() => {
        questionBoxView.addAnswer();
      });
    }
  }

  jointGraph.addCells(answersBatch);
  if (!serializedGraph.allElementsHaveSizeAndPosition) {
    questionBoxView.resizeQuestionBox();
  }
}


/**
 * Deserializes the given SurveyFeedbackBox's urveyFeedbackAnswers into the given jointJS graph
 */
function deserializeSurveyFeedbackAnswers(joint, serializedGraph, serializedBox, jointGraph, paper) {

  const box = jointGraph.getCell(serializedBox.id);
  const boxView = paper.findViewByModel(box);
  const childrenBatch = [];
  const answsersData = []; // rebuild answers in box's elementData, as ids will be wrong in case of a duplicated box
  for (let childId of serializedBox.children) {

    let child = serializedGraph.elements[childId];
    if (child.type == 'userInput') {
      const userInput = new joint.shapes.html.UserInput({
        id: child.id,
        position: child.position,
        size: child.size
      });
      childrenBatch.push(userInput);
    }
    else {
      childrenBatch.push(boxView.createAnswer(child.id, child.position, child.size, child.elementData));
      answsersData.push({
        'id': child.id,
        'score': child.elementData.score,
        'label': child.elementData.label,
      });
    }
  }
  if (box.get('elementData')) {
    box.get('elementData').answers = answsersData;
  }
  childrenBatch.forEach(child => box.embed(child));
  jointGraph.addCells(childrenBatch);
  if (!serializedGraph.allElementsHaveSizeAndPosition) {
    boxView.resizeBox();
  }
}


/**
 * Deserializes the given SubBotBox's SubBotExits into the given jointJS graph
 */
function deserializeSubBotExits(joint, serializedGraph, serializedBox, jointGraph, paper) {

  const box = jointGraph.getCell(serializedBox.id);
  const boxView = paper.findViewByModel(box);
  const childrenBatch = [];
  for (let childId of serializedBox.children) {
    let child = serializedGraph.elements[childId];
    childrenBatch.push(boxView.createExit(child.id, child.position, child.size, child.elementData));
  }
  jointGraph.addCells(childrenBatch);
  if (!serializedGraph.allElementsHaveSizeAndPosition) {
    boxView.resizeBox();
  }
  if (boxView.reorderChildren) {
    boxView.reorderChildren();
  }
}


function deserializeWhatsappTemplateExits(joint, serializedGraph, serializedBox, jointGraph, paper) {

  const box = jointGraph.getCell(serializedBox.id);
  const boxView = paper.findViewByModel(box);
  const childrenBatch = [];
  for (let childId of serializedBox.children) {
    let child = serializedGraph.elements[childId];
    if (child.type === 'whatsappTemplateExit') {
      childrenBatch.push(boxView.createExit(child.id, child.position, child.size, child.elementData));
    }
  }
  jointGraph.addCells(childrenBatch);
  if (!serializedGraph.allElementsHaveSizeAndPosition) {
    boxView.resizeBox();
  }
  boxView.updateValidity();
}

/**
 * Deserializes the given Action's TagAction and TransferAction children into the given jointJS graph 
 * (its Next child will be deserialized with a call to the deserializeNext method)
 */
function deserializeActions(joint, serializedGraph, serializedActionBox, jointGraph, paper, context) {

  let actionBox = jointGraph.getCell(serializedActionBox.id);
  let actionBoxView = paper.findViewByModel(actionBox);

  for (let childId of serializedActionBox.children) {
    let child = serializedGraph.elements[childId];
    if (child.type != 'next') {
      deserializeAction(child, actionBoxView, context);
    }

  }
  // the 'Next' child will be last and will trigger a call resizeBox
}

function deserializeAction(serializedActionShape, actionBoxView, context) {
  const id = serializedActionShape.id;

  if (serializedActionShape.type === 'tagAction') {
    serializedActionShape.description = buildTagActionDescription(serializedActionShape, context);
  } else if (serializedActionShape.type === 'tagFromVariableAction') {
    serializedActionShape.description = buildTagFromVariableActionDescription(serializedActionShape, context);
  }

  actionBoxView.createAction(id, serializedActionShape.position, serializedActionShape.size, serializedActionShape);
}


function buildTagActionDescription(serializedActionShape, context) {
  let description = '';
  let tagGroup;
  let tag;

  if (serializedActionShape.data) {
    tagGroup = context.tagsGroups.find(tg => tg.id === serializedActionShape.data.tagGroupId);
  }
  if (tagGroup) {
    tag = tagGroup.tags_and_categories.find(t => t.id === serializedActionShape.data.tagId);
  }
  if (tag) {
    description = tagGroup['name_' + context.lang] + ' = ' + tag['name_' + context.lang];
  }
  return description;
}


function buildTagFromVariableActionDescription(serializedActionShape, context) {
  let description = '';
  let tagGroup;

  if (serializedActionShape.tagGroupId) {
    tagGroup = context.tagsGroups.find(tg => tg.id === serializedActionShape.tagGroupId);
  }
  if (tagGroup) {
    description = tagGroup['name_' + context.lang] + ' <- ' + serializedActionShape.variableName;
  }
  return description;
}


// Deserializes the persistent menu items associated with facebook get started box
function deserializeMenuItems(joint, serializedGraph, serializedGetStartedBox, jointGraph, paper) {
  let getStartedBox = jointGraph.getCell(serializedGetStartedBox.id);
  let getStartedBoxView = paper.findViewByModel(getStartedBox);

  for (let childId of serializedGetStartedBox.children) {
    let child = serializedGraph.elements[childId];
    if (child.type != 'next') {
      getStartedBoxView.createMenuItem(child.id, child.position, child.size, child.menuItem);
    }
  }
}

/**
 * Deserializes the given box's Next/Then/Else/... child/children into the given jointJS graph
 */
function deserializeNext(joint, serializedGraph, serializedBox, jointGraph, paper) {

  let box = jointGraph.getCell(serializedBox.id);
  let boxView = paper.findViewByModel(box);
  for (let childId of serializedBox.children) {
    let child = serializedGraph.elements[childId];
    let childCellConstructor = null;
    switch (child.type) {
      case 'next':
        childCellConstructor = joint.shapes.html.Next;
        break;
      case 'nextWhatsAppWelcomeMessages':
        childCellConstructor = joint.shapes.html.NextWhatsappWelcomeMessages;
        break;
      case 'then':
        childCellConstructor = joint.shapes.html.Then;
        break;
      case 'else':
        childCellConstructor = joint.shapes.html.Else;
        break;
      case 'whenBH':
        childCellConstructor = joint.shapes.html.WhenBH;
        break;
      case 'whenNBH':
        childCellConstructor = joint.shapes.html.WhenNBH;
        break;
      case 'userInput':
        childCellConstructor = joint.shapes.html.UserInput;
        break;
      case 'recurringNotifAccepted':
        childCellConstructor = joint.shapes.html.RecurringNotifAccepted;
        break;
      case 'optin':
        childCellConstructor = joint.shapes.html.Optin;
        break;
      case 'notOptin':
        childCellConstructor = joint.shapes.html.NotOptin;
        break;
      case 'setCustomFieldSuccess':
        childCellConstructor = joint.shapes.html.SetCustomFieldSuccess;
        break;
      case 'setCustomFieldFail':
        childCellConstructor = joint.shapes.html.SetCustomFieldFail;
        break;
      case 'otherUserInputText':
        childCellConstructor = joint.shapes.html.OtherUserInputText;
        break;
      case 'promoCodeFound':
        childCellConstructor = joint.shapes.html.PromoCodeFound;
        break;
      case 'noPromoCodesAvailable':
        childCellConstructor = joint.shapes.html.NoPromoCodesAvailable;
        break;
      case 'userAlreadyGotPromoCode':
        childCellConstructor = joint.shapes.html.UserAlreadyGotPromoCode;
        break;
      case 'apiConnectorSuccessExit':
        childCellConstructor = joint.shapes.html.ApiConnectorSuccessExit;
        break;
      case 'apiConnectorFailExit':
        childCellConstructor = joint.shapes.html.ApiConnectorFailExit;
        break;
      case 'aiSatisfactionAnswerExit':
        childCellConstructor = joint.shapes.html.AiSatisfactionAnswerExit;
        break;
      case 'textMatchAnswerExit':
        childCellConstructor = joint.shapes.html.TextMatchAnswerExit;
        break;

      default:
        // ignore children that are not nexts
        break;
    }

    if (childCellConstructor) {
      let newCell = new childCellConstructor({
        id: child.id,
        position: child.position,
        size: child.size,
        hasVerbatimMode: child.hasVerbatimMode,
      });
      box.embed(newCell);
      box.graph.addCell(newCell);
    }
  }
  if (!serializedGraph.allElementsHaveSizeAndPosition) {
    boxView.resizeBox();
  }
}

/**
 * Deserializes the given handover's items into the given jointJS graph 
 */
function deserializeHandoverItems(joint, serializedGraph, serializedHandover, jointGraph, paper) {

  // A couple of arrays so that we can display the timeout condition first
  let customConditions = [];
  let timeoutConditions = [];

  // loop on handoverItems
  for (let childId of serializedHandover.children) {
    let child = serializedGraph.elements[childId];
    if (child.type !== 'handoverItem') {
      console.error('expected type=handoverItem for element ' + childId);
    }
    if (typeof child.handoverType === 'undefined') {
      console.error('child.handoverType is undefined (probably a graph with the old handover format) for id ' + childId);
    }
    let newHandoverItem = new joint.shapes.html.HandoverItem({
      id: child.id,
      position: child.position,
      size: child.size,
      data: child.data,
      handoverType: child.handoverType,
      description: child.description
    });
    if (child.handoverType === 'custom') {
      customConditions.push(newHandoverItem);
    } else {
      timeoutConditions.push(newHandoverItem);
    }
  }
  let handover = jointGraph.getCell(serializedHandover.id);
  let handoverView = paper.findViewByModel(handover);
  for (let newHandoverItem of timeoutConditions.concat(customConditions)) {
    handover.embed(newHandoverItem);
    handover.graph.addCell(newHandoverItem);
  }
  if (!serializedGraph.allElementsHaveSizeAndPosition) {
    handoverView.resizeBox();
  }
}

/**
 * Loops on the given box's children and add any links thet might have defined
 * to the given jointJS graph
 */
function deserializeLinks(serializedGraph, children = [], paper, linkFactory, linksBatch) {

  for (let childId of children) {
    let child = serializedGraph.elements[childId];

    // deserialize any links
    if (child.destination_id) {
      let link = linkFactory(paper, {
        source: { id: child.id, port: 'out' },
        target: { id: child.destination_id, port: 'in' }
      });
      linksBatch.push(link);
    }
  }
}

function deserializeMessengerAManoChildren(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {

  let templateBox = jointGraph.getCell(boxId);
  let templateBoxView = paper.findViewByModel(templateBox);
  let itemsBatch = [];
  for (let itemId of boxChildrenIds) {
    let item = serializedGraph.elements[itemId];
    itemsBatch.push(deserializeMessengerAManoChild(joint, item));
  }
  itemsBatch.forEach(item => templateBox.embed(item));
  jointGraph.addCells(itemsBatch);
  templateBoxView.afterDeserialize(!serializedGraph.allElementsHaveSizeAndPosition);
}

function deserializeListPickerBox(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper, services, context) {
  const box = jointGraph.getCell(boxId);
  const boxView = paper.findViewByModel(box);
  boxView.numberOfSections = 0;
  let itemsBatch = [];
  for (let itemId of boxChildrenIds) {
    const item = serializedGraph.elements[itemId];

    if (['userInput', 'unexpectedUserInputExit'].includes(item.type)) {
      const userInput = new joint.shapes.html.UserInput({
        id: item.id,
        position: item.position,
        size: item.size,
        hasVerbatimMode: item.hasVerbatimMode,
      });
      itemsBatch.push(userInput);
    }
    if (item.type === 'listPickerAnswer') {
      const answerElement = boxView.createAnswer(item.id,
        item.position,
        item.size,
        item.elementData);
      itemsBatch.push(answerElement);
    }
    if (item.type === 'listPickerSection') {
      const sectionElement = boxView.createSection(item.id,
        item.position,
        item.size,
        item.elementData);
      itemsBatch.push(sectionElement);
    }
  }

  const sectionBoxNeeded = (boxView.getConfigurationOption('min-section') || 0) - boxView.numberOfSections;
  if (sectionBoxNeeded > 0) {
    Array.from({ length: sectionBoxNeeded }).forEach(() => boxView.addSection());
  }
  const answerBoxNeeded = (boxView.getConfigurationOption('min-answer') || 0) - boxView.numberOfAnswers;
  if (answerBoxNeeded > 0) {
    Array.from({ length: answerBoxNeeded }).forEach(() => boxView.addAnswer());
  }

  itemsBatch.forEach(item => box.embed(item));
  jointGraph.addCells(itemsBatch);
  if (!serializedGraph.allElementsHaveSizeAndPosition) {
    boxView.resizeBox();
  }
  const isWhatsappAccount = context.site.type === services.WhatsappFactory.getType();
  if (!isWhatsappAccount) {
    boxView.model.set('elementData', { message: { text: null } });
  }
}

function deserializeWhatsappMessageWithButtonsBox(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const box = jointGraph.getCell(boxId);
  const boxView = paper.findViewByModel(box);

  let itemsBatch = [];
  for (let itemId of boxChildrenIds) {
    const item = serializedGraph.elements[itemId];
    if (['userInput', 'unexpectedUserInputExit'].includes(item.type)) {
      const userInput = new joint.shapes.html.UserInput({
        id: item.id,
        position: item.position,
        size: item.size,
        hasVerbatimMode: item.hasVerbatimMode,
      });
      itemsBatch.push(userInput);
    }
    if (item.type == 'whatsappMessageWithButtonsButton') {
      const answerElement = boxView.createButton(item.id,
        item.position,
        item.size,
        item.elementData);
      itemsBatch.push(answerElement);
    }
  }
  itemsBatch.forEach(item => box.embed(item));
  jointGraph.addCells(itemsBatch);
  if (!serializedGraph.allElementsHaveSizeAndPosition) {
    boxView.resizeBox();
  }
}

function deserializeForkWithDelayBox(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const box = jointGraph.getCell(boxId);
  const boxView = paper.findViewByModel(box);

  let itemsBatch = [];
  for (let itemId of boxChildrenIds) {
    const item = serializedGraph.elements[itemId];
    if (item.type == 'next') {
      const next = new joint.shapes.html.Next({
        id: item.id,
        position: item.position,
        size: item.size
      });
      itemsBatch.push(next);
    }
    if (item.type == 'nextWithDelay') {
      const next = new joint.shapes.html.NextWithDelay({
        id: item.id,
        position: item.position,
        size: item.size
      });
      itemsBatch.push(next);
    }
  }
  itemsBatch.forEach(item => box.embed(item));
  jointGraph.addCells(itemsBatch);
  if (!serializedGraph.allElementsHaveSizeAndPosition) {
    boxView.resizeBox();
  }
}

function deserializeMessageWithoutQRURLButtons(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const box = jointGraph.getCell(boxId);
  const boxView = paper.findViewByModel(box);

  let itemsBatch = [];
  for (let itemId of boxChildrenIds) {
    const item = serializedGraph.elements[itemId];
    if (item.type == 'messageWithoutQRURLButton') {
      const answerElement = boxView.createButton(item.id,
        item.position,
        item.size,
        item.elementData);
      itemsBatch.push(answerElement);
    }
  }
  itemsBatch.forEach(item => box.embed(item));
  jointGraph.addCells(itemsBatch);
  if (!serializedGraph.allElementsHaveSizeAndPosition) {
    boxView.resizeBox();
  }
}

function deserializeCarrouselBox(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const box = jointGraph.getCell(boxId);
  const boxView = paper.findViewByModel(box);

  let itemsBatch = [];
  for (let itemId of boxChildrenIds) {
    let item = serializedGraph.elements[itemId];
    if (item.type !== 'next') {
      itemsBatch.push(deserializeCarrouselChild(boxView, joint, item));
    }
  }
  itemsBatch.forEach(item => box.embed(item));
  jointGraph.addCells(itemsBatch);
  boxView.afterDeserialize(!serializedGraph.allElementsHaveSizeAndPosition);
}

function deserializeCarrouselChild(boxView, joint, item) {
  switch (item.type) {
    case 'carrouselButtonGroupHeader':
      return boxView.createCarrouselButtonGroupHeader(item.id,
        item.elementData.carouselElementId,
        item.position,
        item.size,
        item.elementData);
    case 'carrouselAddButtonButton':
      return boxView.createCarrouselAddButtonButton(item.id,
        item.elementData.carouselElementId,
        item.position,
        item.size,
        item.elementData);
    case 'carrouselElementButton':
    case 'imageCarrouselElementButton':
      return boxView.createCarrouselElementButton(item.id,
        item.elementData.carouselElementId,
        item.position,
        item.size,
        item.elementData);
  }
}

function deserializeImageMapBox(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const box = jointGraph.getCell(boxId);
  const boxView = paper.findViewByModel(box);

  let itemsBatch = [];
  for (let itemId of boxChildrenIds) {
    let item = serializedGraph.elements[itemId];
    if (item.type !== 'next' && item.type !== 'userInput') {
      itemsBatch.push(deserializeImageMapBoxChild(boxView, item));
    }
  }
  itemsBatch.forEach(item => box.embed(item));
  jointGraph.addCells(itemsBatch);
}

function deserializeImageMapBoxChild(boxView, item) {
  switch (item.type) {
    case 'imageMapZone':
      return boxView.createImageMapZone(item.id, item.position, item.size, item.elementData);
    case 'imageMapAddZoneButton':
      return boxView.createImageMapAddZoneButton(item.id, item.elementData.carouselElementId, item.position, item.size, item.elementData);
  }
}

function deserializeMessengerAManoChild(joint, item) {
  switch (item.type) {
    case 'messengerButtonGroupHeader':
      return new joint.shapes.html.MessengerButtonGroupHeader({
        id: item.id,
        position: item.position,
        size: item.size,
        carouselElementId: item.carouselElementId
      });
    case 'messengerAddButton':
      const addChildId = item.addChildId !== undefined
        ? item.addChildId
        : item.carouselElementId; // TODO Pascal edit and save all scenarios and remove this line
      return newAddChild(joint.shapes.html.MessengerAddButton, item.id, addChildId, item.position, item.size);
    case 'messengerAddGlobalButton':
      return newAddChild(joint.shapes.html.MessengerAddGlobalButton, item.id, item.addChildId, item.position, item.size);
    case 'messengerButton':
      return new joint.shapes.html.MessengerButton({
        id: item.id,
        position: item.position,
        size: item.size,
        carouselElementId: item.carouselElementId,
        button: item.button
      });
    case 'messengerListItem':
      return new joint.shapes.html.MessengerListItem({
        id: item.id,
        position: item.position,
        size: item.size,
        item: item.item
      });
  }

  function newAddChild(constructor, id, addChildId, position, size) {
    return new constructor({
      id: id,
      position: position,
      size: size,
      addChildId: addChildId
    });
  }
}

function deserializeUserLanguages(joint, serializedGraph, serializedUserLanguages, jointGraph, paper) {

  const userLanguagesBox = jointGraph.getCell(serializedUserLanguages.id);
  const userLanguagesBoxView = paper.findViewByModel(userLanguagesBox);

  let languagesBatch = [];
  for (let languageId of serializedUserLanguages.children) {
    const language = serializedGraph.elements[languageId];
    languagesBatch.push(userLanguagesBoxView.createUserLanguage(language.id, language.elementData));
  }
  jointGraph.addCells(languagesBatch);
}

function deserializeUserCountries(joint, serializedGraph, serializedUserCountries, jointGraph, paper) {

  const userCountriesBox = jointGraph.getCell(serializedUserCountries.id);
  const userCountriesBoxView = paper.findViewByModel(userCountriesBox);

  let countriesBatch = [];
  for (let id of serializedUserCountries.children) {
    const element = serializedGraph.elements[id];
    countriesBatch.push(userCountriesBoxView.createUserCountry(element.id, element.elementData));
  }
  jointGraph.addCells(countriesBatch);
}

function deserializeConfirmBox(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const box = jointGraph.getCell(boxId);
  const boxView = paper.findViewByModel(box);

  let itemsBatch = [];
  for (let itemId of boxChildrenIds) {
    let item = serializedGraph.elements[itemId];
    itemsBatch.push(boxView.createConfirmButton(item.id,
      item.position,
      item.size,
      item.elementData)
    );
  }
  itemsBatch.forEach(item => box.embed(item));
  jointGraph.addCells(itemsBatch);

}
function deserializeConditionsOnUserInputBox(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const conditionsOnUserInputBox = jointGraph.getCell(boxId);
  const conditionsOnUserInputBoxView = paper.findViewByModel(conditionsOnUserInputBox);

  let conditions = [];
  for (let conditionId of boxChildrenIds) {
    const condition = serializedGraph.elements[conditionId];
    if (condition.type !== 'otherUserInputText') {
      conditions.push(conditionsOnUserInputBoxView.createCondition(condition.id, condition.position, condition.size, condition.elementData));
    }
  }
  jointGraph.addCells(conditions);
  conditions.forEach(item => conditionsOnUserInputBox.embed(item));
}
function deserializeConditionsVariablesMultipleBox(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const box = jointGraph.getCell(boxId);
  const boxView = paper.findViewByModel(box);
  boxView.numberOfValueChild = 0;

  let valueChildren = [];
  for (let valueChildId of boxChildrenIds) {
    const valueChild = serializedGraph.elements[valueChildId];
    if (valueChild.type !== 'else') {
      valueChildren.push(boxView.createValueChild(valueChild.id, valueChild.position, valueChild.size, valueChild.elementData));
      boxView.numberOfValueChild++;
    }
  }
  jointGraph.addCells(valueChildren);
  valueChildren.forEach(item => box.embed(item));
  boxView.updateValidity();
}

function deserializeWhatsappWelcomeMessageBox(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const box = jointGraph.getCell(boxId);
  const boxView = paper.findViewByModel(box);
  boxView.numberOfIceBreaker = 0;

  let iceBreakers = [];
  for (let iceBreakerId of boxChildrenIds) {
    const iceBreaker = serializedGraph.elements[iceBreakerId];
    if (iceBreaker.type !== 'userInput' && iceBreaker.type !== 'nextWhatsAppWelcomeMessages') {
      iceBreakers.push(boxView.createIceBreaker(iceBreaker.id, iceBreaker.position, iceBreaker.size, iceBreaker.elementData));
      boxView.numberOfIceBreaker++;
    }
  }
  jointGraph.addCells(iceBreakers);
  iceBreakers.forEach(item => box.embed(item));
  boxView.updateValidity();
}

function deserializeAISatisfactionBox(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const box = jointGraph.getCell(boxId);
  const boxView = paper.findViewByModel(box);
  let outputs = [];
  for (let childId of boxChildrenIds) {
    const child = serializedGraph.elements[childId];
    if (child.type !== 'userInput') {
      outputs.push(boxView.createOutput(child.id, child.position, child.size, child.elementData));
    }
  }
  jointGraph.addCells(outputs);
  outputs.forEach(item => box.embed(item));
  boxView.updateValidity();
}

function deserializeTextMatchBox(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const box = jointGraph.getCell(boxId);
  const boxView = paper.findViewByModel(box);
  let outputs = [];
  for (let childId of boxChildrenIds) {
    const child = serializedGraph.elements[childId];
    outputs.push(boxView.createOutput(child.id, child.position, child.size, child.elementData));
  }
  jointGraph.addCells(outputs);
  outputs.forEach(item => box.embed(item));
  boxView.updateValidity();
}

function deserializeOptinCTSTitle(joint, serializedGraph, boxId, boxChildrenIds, jointGraph, paper) {
  const OptinCTSBox = jointGraph.getCell(boxId);
  const OptinCTSBoxView = paper.findViewByModel(OptinCTSBox);
  if (boxChildrenIds.length > 0) {
    const currentOptinCTSTitle = serializedGraph.elements[boxChildrenIds[0]];
    jointGraph.addCells(OptinCTSBoxView.createOptinCTSTitle(currentOptinCTSTitle.id, currentOptinCTSTitle.elementData));
  }
}
